<template>
  <MModal :visible="visible" :title="$t(`Common.title.payCost`)" :zIndex="999" wrapClassName="pdf__view"
    @change="onVisibleChange" @ok="onConfirm" :okText="$t('Common.action.confirm')"
    :cancelText="$t('Common.action.cancel')">
    <m-form ref="form">
      <m-input is-form-item v-model="form.clientName" :label="this.$t(`apply.title.userName`)" :rules="[
        {
          required: true,
          message: this.$t(`Common.message.pleaseEnter`),
        },
      ]"></m-input>
      <m-input is-form-item v-model="form.email" :label="this.$t('apply.title.email')" :rules="[
        {
          pattern: emailNum,
          message: this.$t('Common.message.formatError'),
        },
      ]">
      </m-input>
      <m-input is-form-item v-model="form.confirmEmail" :label="this.$t('apply.title.confirmEmail')" :rules="[
        {
          pattern: emailNum,
          message: this.$t('Common.message.formatError'),
        },
      ]"></m-input>
    </m-form>
  </MModal>
</template>

<script>
import { PaymentAPI } from 'govmo-common/src/api';
import { emailNum } from 'govmo-common/src/utils/utils';
import ThrottleMixin from "govmo-common/src/mixins/ThrottleMixin";
export default {
  name: 'Home',
  components: {},
  mixins: [ThrottleMixin],
  props: {
    visible: Boolean,
    fetch: Function,
    refreshPay: Function,
    data: Object,
  },
  data() {
    return {
      form: {},
      searchData: {},
      emailNum: emailNum(),
    };
  },
  created() {
    this.toPay = this.createThrottledFunction(this.toConfirmPay, 'confirmPay', 1000);
  },
  methods: {
    onVisibleChange(val) {
      this.$emit('update:visible', val);
    },
    async toConfirmPay() {
      if (!(await this.$refs.form.validateFields())) return;
      if (
        (this.form.email || this.form.confirmEmail)
        &&
        this.form.email !== this.form.confirmEmail
      ) {
        this.$error(this.$t("apply.title.confirmEmail"));
        return;
      }
      this.onPay();
    },
    async onConfirm() {
      this.toPay()
    },
    //提交支付
    async onPay() {
      this.$showLoading();
      try {
        const { illegalYear, autoNo, docNo, clientName, email } = this.form;
        const params = {
          illegalYear,
          autoNo,
          docNo,
          clientName,
          email,
        };
        const { redirect, transactionNo, signature, expire } = await PaymentAPI.startPayment(params);

        if (redirect && transactionNo && signature) {
          setTimeout(() => {
            window.open(redirect, '_blank');
          }, 0);
          this.refreshPay(transactionNo);
          this.onVisibleChange(false);
        }
      } catch (error) {
        const errorBody = error.response?.data

        if (errorBody && errorBody.code === 'PAYMENT_START_PAYING') {
          const nextPayTime = errorBody.nextPayTime
          this.$alert({
            message: this.$t(`ERROR_CODE_MESSAGE.PAYMENT_START_PAYING`, { time: nextPayTime }),
          });
        } else {
          this.$error(error);
        }

        console.log("测试返回数据", errorBody);

        this.$hideLoading();
      } finally {

      }
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(val) {
        if (val !== null) {
          this.form = val;
        }
      },
    },
  },
};
</script>
